import { m8API } from 'services/production/m8';
import { normalizeM8PaymentTransactionDTO } from 'services/production/utils/normalizeM8PaymentTransactionDTO';
import { GetCardPaymentService } from 'types/services';

export const getCardPayment: GetCardPaymentService = async (paymentId) => {
  const m8PaymentTransaction = await m8API.admin.getPaymentTransactionsById({
    id: paymentId,
  });

  return normalizeM8PaymentTransactionDTO(m8PaymentTransaction).toCardPayment();
};
